import * as React from 'react'
import { Animated, Dimensions, ScrollView, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

const HEIGHT = Dimensions.get('window').height
const HEADER_HEIGHT = 16
const TOP = 50
const SURFACE = HEIGHT - TOP - HEADER_HEIGHT

const Component = ({ render, fixed, backgroundColor = theme.colors.modalBackground }: DrawerComponentProps) => {
  const translate = React.useMemo(() => new Animated.ValueXY({ x: 0, y: HEIGHT }), [])

  const open = () => {
    Animated.timing(translate, { toValue: { x: 0, y: TOP }, useNativeDriver: false, duration: 300 }).start()
  }

  React.useEffect(() => {
    open()
  }, [])

  const ContentRender = render

  const trans = translate.y.interpolate({ inputRange: [TOP, HEIGHT], outputRange: [TOP, HEIGHT], extrapolate: 'clamp' })
  const opacity = trans.interpolate({ inputRange: [TOP, HEIGHT], outputRange: [0.8, 0.2] })

  return (
    <MainContainer pointerEvents="box-none">
      <Back style={{ opacity }} />

      <PopupContainer style={{ transform: [{ translateY: trans }], backgroundColor }}>
        {fixed ? (
          <View style={{ height: SURFACE }}>
            <ContentRender />
          </View>
        ) : (
          <ScrollView style={{ height: SURFACE }} bounces={false} contentContainerStyle={{ flexGrow: 1 }}>
            <ContentRender />
          </ScrollView>
        )}
      </PopupContainer>
    </MainContainer>
  )
}

export default Component

const MainContainer = styled(Animated.View)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
`

const Back = styled(Animated.View)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0005;
`

// COMPONENT

const PopupContainer = styled(Animated.View)`
  ${(props) => props.theme.constants.shadow};
  position: absolute;
  left: 0;
  right: 0;
  border-top-left-radius: ${HEADER_HEIGHT}px;
  border-top-right-radius: ${HEADER_HEIGHT}px;
  padding-top: ${HEADER_HEIGHT}px;
`
